import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma,
  JsonDecodingException1p97qvfqhd5n3 as JsonDecodingException,
  throwInvalidFloatingPointDecoded3ghwdo6vya1kj as throwInvalidFloatingPointDecoded,
} from './JsonExceptions.mjs';
import {
  getJsonNameIndex1fee1p51fy8fj as getJsonNameIndex,
  ignoreUnknownKeys1ot1okvsp9ttf as ignoreUnknownKeys,
  getJsonNameIndexOrThrow1a6a29i1xie0m as getJsonNameIndexOrThrow,
} from './JsonNamesMap.mjs';
import { ENUM_getInstance22lfbrqor0c0a as ENUM_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { AbstractDecoder35guh02ubh2hm as AbstractDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractDecoder.mjs';
import { JsonElementMarker395jk2pil4789 as JsonElementMarker } from './JsonElementMarker.mjs';
import { JsonTreeReader1ycreu77eikqj as JsonTreeReader } from './JsonTreeReader.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import { classDiscriminator9fd3hvqsgfqq as classDiscriminator } from './Polymorphic.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  get_jsonPrimitivez17tyd5rw1ql as get_jsonPrimitive,
  get_contentOrNull35s97cgi8z9eo as get_contentOrNull,
} from '../JsonElement.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import {
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  MissingFieldException24tqif29emcmi as MissingFieldException,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { readPolymorphicJson7wfdzotvo8aj as readPolymorphicJson } from './TreeJsonDecoder.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  substringAfter1hku067gwr5ve as substringAfter,
  contains3ue2qo8xhmpf1 as contains,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { plus17rl43at52ays as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  switchMode35g725ikhjpwv as switchMode,
  WriteMode_MAP_getInstance1kyp6ms3wufvk as WriteMode_MAP_getInstance,
} from './WriteMode.mjs';
import {
  convertToByte2t4hntblnhq2k as convertToByte,
  fromInt2ii0rejb1w62w as fromInt,
  convertToShortn6n5n7ruahkm as convertToShort,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toDouble1kn912gjoizjp as toDouble } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_isUnsignedNumber3dxwaa3af8ncr as get_isUnsignedNumber } from './StreamingJsonEncoder.mjs';
import { JsonDecoder1rijst5ne6qla as JsonDecoder } from '../JsonDecoder.mjs';
import {
  toUInt21lx0mz8wkp7c as toUInt,
  toULong266mnyksbttkw as toULong,
  toUByteh6p4wmqswkrs as toUByte,
  toUShort7yqspfnhrot4 as toUShort,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/UStrings.mjs';
import { _UInt___get_data__impl__f0vqqw13y1a2xkii3dn as _UInt___get_data__impl__f0vqqw } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { _ULong___get_data__impl__fggpzb2qlkrfp9zs48z as _ULong___get_data__impl__fggpzb } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { _UByte___get_data__impl__jof9qr2p2xx2i2jvnz8 as _UByte___get_data__impl__jof9qr } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { _UShort___get_data__impl__g0245hlms5v6vgvnl as _UShort___get_data__impl__g0245 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DiscriminatorHolderClass;
function DiscriminatorHolder() {
  if (DiscriminatorHolderClass === VOID) {
    class $ {
      constructor(discriminatorToSkip) {
        this.c2f_1 = discriminatorToSkip;
      }
    }
    initMetadataForClass($, 'DiscriminatorHolder');
    DiscriminatorHolderClass = $;
  }
  return DiscriminatorHolderClass;
}
function trySkip($this, _this__u8e3s4, unknownKey) {
  if (_this__u8e3s4 == null)
    return false;
  if (_this__u8e3s4.c2f_1 === unknownKey) {
    _this__u8e3s4.c2f_1 = null;
    return true;
  }
  return false;
}
function skipLeftoverElements($this, descriptor) {
  while (!($this.b14(descriptor) === -1)) {
  }
}
function checkLeadingComma($this) {
  if ($this.d28_1.r2e() === 4) {
    $this.d28_1.f2d('Unexpected leading comma');
  }
}
function decodeMapIndex($this) {
  var hasComma = false;
  var decodingKey = !(($this.f28_1 % 2 | 0) === 0);
  if (decodingKey) {
    if (!($this.f28_1 === -1)) {
      hasComma = $this.d28_1.e2f();
    }
  } else {
    $this.d28_1.d2f(_Char___init__impl__6a9atx(58));
  }
  var tmp;
  if ($this.d28_1.t2e()) {
    if (decodingKey) {
      if ($this.f28_1 === -1) {
        var tmp0 = $this.d28_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = !hasComma;
        var position = tmp0.j28_1;
        if (!condition) {
          var tmp$ret$0 = 'Unexpected leading comma';
          tmp0.f2d(tmp$ret$0, position);
        }
      } else {
        var tmp0_0 = $this.d28_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition_0 = hasComma;
        var position_0 = tmp0_0.j28_1;
        if (!condition_0) {
          var tmp$ret$2 = 'Expected comma after the key-value pair';
          tmp0_0.f2d(tmp$ret$2, position_0);
        }
      }
    }
    $this.f28_1 = $this.f28_1 + 1 | 0;
    tmp = $this.f28_1;
  } else {
    if (hasComma && !$this.b28_1.u27_1.v29_1) {
      invalidTrailingComma($this.d28_1);
    }
    tmp = -1;
  }
  return tmp;
}
function coerceInputValue($this, descriptor, index) {
  var tmp0 = $this.b28_1;
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var isOptional = descriptor.z11(index);
    var elementDescriptor = descriptor.y11(index);
    var tmp;
    if (isOptional && !elementDescriptor.l11()) {
      tmp = $this.d28_1.f2f(true);
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$1 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.s11(), ENUM_getInstance())) {
      var tmp_0;
      if (elementDescriptor.l11()) {
        tmp_0 = $this.d28_1.f2f(false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$1 = false;
        break $l$block_2;
      }
      var tmp0_elvis_lhs = $this.d28_1.g2f($this.h28_1.j29_1);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$1 = false;
        break $l$block_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_1;
      var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
      var coerceToNull = !tmp0.u27_1.m29_1 && elementDescriptor.l11();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        $this.d28_1.u2e();
        tmp$ret$1 = true;
        break $l$block_2;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
}
function decodeObjectIndex($this, descriptor) {
  var hasComma = $this.d28_1.e2f();
  while ($this.d28_1.t2e()) {
    hasComma = false;
    var key = decodeStringKey($this);
    $this.d28_1.d2f(_Char___init__impl__6a9atx(58));
    var index = getJsonNameIndex(descriptor, $this.b28_1, key);
    var tmp;
    if (!(index === -3)) {
      var tmp_0;
      if ($this.h28_1.o29_1 && coerceInputValue($this, descriptor, index)) {
        hasComma = $this.d28_1.e2f();
        tmp_0 = false;
      } else {
        var tmp0_safe_receiver = $this.i28_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.w2c(index);
        }
        return index;
      }
      tmp = tmp_0;
    } else {
      tmp = true;
    }
    var isUnknown = tmp;
    if (isUnknown) {
      hasComma = handleUnknown($this, descriptor, key);
    }
  }
  if (hasComma && !$this.b28_1.u27_1.v29_1) {
    invalidTrailingComma($this.d28_1);
  }
  var tmp1_safe_receiver = $this.i28_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.x2c();
  return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
}
function handleUnknown($this, descriptor, key) {
  if (ignoreUnknownKeys(descriptor, $this.b28_1) || trySkip($this, $this.g28_1, key)) {
    $this.d28_1.i2f($this.h28_1.j29_1);
  } else {
    $this.d28_1.k28_1.x2d();
    $this.d28_1.h2f(key);
  }
  return $this.d28_1.e2f();
}
function decodeListIndex($this) {
  var hasComma = $this.d28_1.e2f();
  var tmp;
  if ($this.d28_1.t2e()) {
    if (!($this.f28_1 === -1) && !hasComma) {
      $this.d28_1.f2d('Expected end of the array or comma');
    }
    $this.f28_1 = $this.f28_1 + 1 | 0;
    tmp = $this.f28_1;
  } else {
    if (hasComma && !$this.b28_1.u27_1.v29_1) {
      invalidTrailingComma($this.d28_1, 'array');
    }
    tmp = -1;
  }
  return tmp;
}
function decodeStringKey($this) {
  var tmp;
  if ($this.h28_1.j29_1) {
    tmp = $this.d28_1.k2f();
  } else {
    tmp = $this.d28_1.j2f();
  }
  return tmp;
}
var StreamingJsonDecoderClass;
function StreamingJsonDecoder() {
  if (StreamingJsonDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(json, mode, lexer, descriptor, discriminatorHolder) {
        super();
        this.b28_1 = json;
        this.c28_1 = mode;
        this.d28_1 = lexer;
        this.e28_1 = this.b28_1.mz();
        this.f28_1 = -1;
        this.g28_1 = discriminatorHolder;
        this.h28_1 = this.b28_1.u27_1;
        this.i28_1 = this.h28_1.m29_1 ? null : new (JsonElementMarker())(descriptor);
      }
      c2a() {
        return this.b28_1;
      }
      mz() {
        return this.e28_1;
      }
      d2a() {
        return (new (JsonTreeReader())(this.b28_1.u27_1, this.d28_1)).w2e();
      }
      qz(deserializer) {
        try {
          var tmp;
          if (!(deserializer instanceof AbstractPolymorphicSerializer())) {
            tmp = true;
          } else {
            tmp = this.b28_1.u27_1.p29_1;
          }
          if (tmp) {
            return deserializer.pz(this);
          }
          var discriminator = classDiscriminator(deserializer.az(), this.b28_1);
          var tmp0_elvis_lhs = this.d28_1.l2f(discriminator, this.h28_1.j29_1);
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            var tmp2 = isInterface(deserializer, DeserializationStrategy()) ? deserializer : THROW_CCE();
            var tmp$ret$0;
            $l$block: {
              // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
              var tmp_1;
              if (!(tmp2 instanceof AbstractPolymorphicSerializer())) {
                tmp_1 = true;
              } else {
                tmp_1 = this.c2a().u27_1.p29_1;
              }
              if (tmp_1) {
                tmp$ret$0 = tmp2.pz(this);
                break $l$block;
              }
              var discriminator_0 = classDiscriminator(tmp2.az(), this.c2a());
              var tmp0 = this.d2a();
              // Inline function 'kotlinx.serialization.json.internal.cast' call
              var serialName = tmp2.az().h10();
              if (!(tmp0 instanceof JsonObject())) {
                var tmp_2 = getKClass(JsonObject()).ff();
                var tmp_3 = getKClassFromExpression(tmp0).ff();
                var tmp$ret$1 = this.d28_1.k28_1.y2d();
                throw JsonDecodingException(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString(tmp0));
              }
              var jsonTree = tmp0;
              var tmp0_safe_receiver = jsonTree.gi(discriminator_0);
              var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
              var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
              var tmp_4;
              try {
                tmp_4 = findPolymorphicSerializer(tmp2, this, type);
              } catch ($p) {
                var tmp_5;
                if ($p instanceof SerializationException()) {
                  var it = $p;
                  throw JsonDecodingException(-1, ensureNotNull(it.message), jsonTree.toString());
                } else {
                  throw $p;
                }
              }
              var tmp_6 = tmp_4;
              var actualSerializer = isInterface(tmp_6, DeserializationStrategy()) ? tmp_6 : THROW_CCE();
              tmp$ret$0 = readPolymorphicJson(this.c2a(), discriminator_0, jsonTree, actualSerializer);
            }
            return tmp$ret$0;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var type_0 = tmp_0;
          var tmp_7;
          try {
            tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
          } catch ($p) {
            var tmp_8;
            if ($p instanceof SerializationException()) {
              var it_0 = $p;
              var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
              var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
              this.d28_1.f2d(message, VOID, hint);
            } else {
              throw $p;
            }
            tmp_7 = tmp_8;
          }
          var tmp_9 = tmp_7;
          var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy()) ? tmp_9 : THROW_CCE();
          this.g28_1 = new (DiscriminatorHolder())(discriminator);
          return actualSerializer_0.pz(this);
        } catch ($p) {
          if ($p instanceof MissingFieldException()) {
            var e = $p;
            if (contains(ensureNotNull(e.message), 'at path'))
              throw e;
            throw MissingFieldException().e11(e.c11_1, plus(e.message, ' at path: ') + this.d28_1.k28_1.y2d(), e);
          } else {
            throw $p;
          }
        }
      }
      l13(descriptor) {
        var newMode = switchMode(this.b28_1, descriptor);
        this.d28_1.k28_1.t2d(descriptor);
        this.d28_1.d2f(newMode.o2f_1);
        checkLeadingComma(this);
        var tmp;
        switch (newMode.b4_1) {
          case 1:
          case 2:
          case 3:
            tmp = new (StreamingJsonDecoder())(this.b28_1, newMode, this.d28_1, descriptor, this.g28_1);
            break;
          default:
            var tmp_0;
            if (this.c28_1.equals(newMode) && this.b28_1.u27_1.m29_1) {
              tmp_0 = this;
            } else {
              tmp_0 = new (StreamingJsonDecoder())(this.b28_1, newMode, this.d28_1, descriptor, this.g28_1);
            }

            tmp = tmp_0;
            break;
        }
        return tmp;
      }
      m13(descriptor) {
        if (descriptor.u11() === 0 && ignoreUnknownKeys(descriptor, this.b28_1)) {
          skipLeftoverElements(this, descriptor);
        }
        if (this.d28_1.e2f() && !this.b28_1.u27_1.v29_1) {
          invalidTrailingComma(this.d28_1, '');
        }
        this.d28_1.d2f(this.c28_1.p2f_1);
        this.d28_1.k28_1.x2d();
      }
      x12() {
        var tmp;
        var tmp0_safe_receiver = this.i28_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v2c_1;
        if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
          tmp = !this.d28_1.q2f();
        } else {
          tmp = false;
        }
        return tmp;
      }
      y12() {
        return null;
      }
      x13(descriptor, index, deserializer, previousValue) {
        var isMapKey = this.c28_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
        if (isMapKey) {
          this.d28_1.k28_1.w2d();
        }
        var value = super.x13(descriptor, index, deserializer, previousValue);
        if (isMapKey) {
          this.d28_1.k28_1.v2d(value);
        }
        return value;
      }
      b14(descriptor) {
        var index;
        switch (this.c28_1.b4_1) {
          case 0:
            index = decodeObjectIndex(this, descriptor);
            break;
          case 2:
            index = decodeMapIndex(this);
            break;
          default:
            index = decodeListIndex(this);
            break;
        }
        if (!this.c28_1.equals(WriteMode_MAP_getInstance())) {
          this.d28_1.k28_1.u2d(index);
        }
        return index;
      }
      z12() {
        return this.d28_1.r2f();
      }
      a13() {
        var value = this.d28_1.s2f();
        if (!(value === fromInt(convertToByte(value)))) {
          this.d28_1.f2d("Failed to parse byte for input '" + value.toString() + "'");
        }
        return convertToByte(value);
      }
      b13() {
        var value = this.d28_1.s2f();
        if (!(value === fromInt(convertToShort(value)))) {
          this.d28_1.f2d("Failed to parse short for input '" + value.toString() + "'");
        }
        return convertToShort(value);
      }
      c13() {
        var value = this.d28_1.s2f();
        if (!(value === fromInt(convertToInt(value)))) {
          this.d28_1.f2d("Failed to parse int for input '" + value.toString() + "'");
        }
        return convertToInt(value);
      }
      d13() {
        return this.d28_1.s2f();
      }
      e13() {
        var tmp0 = this.d28_1;
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.v2e();
          try {
            // Inline function 'kotlin.text.toFloat' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp$ret$4 = toDouble(input);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.f2d("Failed to parse type '" + 'float' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$4;
        var specialFp = this.b28_1.u27_1.r29_1;
        if (specialFp || isFinite(result))
          return result;
        throwInvalidFloatingPointDecoded(this.d28_1, result);
      }
      f13() {
        var tmp0 = this.d28_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.v2e();
          try {
            tmp$ret$1 = toDouble(input);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.f2d("Failed to parse type '" + 'double' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$1;
        var specialFp = this.b28_1.u27_1.r29_1;
        if (specialFp || isFinite_0(result))
          return result;
        throwInvalidFloatingPointDecoded(this.d28_1, result);
      }
      g13() {
        var string = this.d28_1.v2e();
        if (!(string.length === 1)) {
          this.d28_1.f2d("Expected single char, but got '" + string + "'");
        }
        return charCodeAt(string, 0);
      }
      h13() {
        var tmp;
        if (this.h28_1.j29_1) {
          tmp = this.d28_1.k2f();
        } else {
          tmp = this.d28_1.u2e();
        }
        return tmp;
      }
      j13(descriptor) {
        return get_isUnsignedNumber(descriptor) ? new (JsonDecoderForUnsignedTypes())(this.d28_1, this.b28_1) : super.j13(descriptor);
      }
      i13(enumDescriptor) {
        return getJsonNameIndexOrThrow(enumDescriptor, this.b28_1, this.h13(), ' at path ' + this.d28_1.k28_1.y2d());
      }
    }
    initMetadataForClass($, 'StreamingJsonDecoder', VOID, VOID, [JsonDecoder(), AbstractDecoder()]);
    StreamingJsonDecoderClass = $;
  }
  return StreamingJsonDecoderClass;
}
var JsonDecoderForUnsignedTypesClass;
function JsonDecoderForUnsignedTypes() {
  if (JsonDecoderForUnsignedTypesClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(lexer, json) {
        super();
        this.t2f_1 = lexer;
        this.u2f_1 = json.mz();
      }
      mz() {
        return this.u2f_1;
      }
      b14(descriptor) {
        var message = 'unsupported';
        throw IllegalStateException().o4(toString(message));
      }
      c13() {
        var tmp0 = this.t2f_1;
        var tmp$ret$2;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.v2e();
          try {
            // Inline function 'kotlin.UInt.toInt' call
            var this_0 = toUInt(input);
            tmp$ret$2 = _UInt___get_data__impl__f0vqqw(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.f2d("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$2;
      }
      d13() {
        var tmp0 = this.t2f_1;
        var tmp$ret$2;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.v2e();
          try {
            // Inline function 'kotlin.ULong.toLong' call
            var this_0 = toULong(input);
            tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.f2d("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$2;
      }
      a13() {
        var tmp0 = this.t2f_1;
        var tmp$ret$2;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.v2e();
          try {
            // Inline function 'kotlin.UByte.toByte' call
            var this_0 = toUByte(input);
            tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.f2d("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$2;
      }
      b13() {
        var tmp0 = this.t2f_1;
        var tmp$ret$2;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.v2e();
          try {
            // Inline function 'kotlin.UShort.toShort' call
            var this_0 = toUShort(input);
            tmp$ret$2 = _UShort___get_data__impl__g0245(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.f2d("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$2;
      }
    }
    initMetadataForClass($, 'JsonDecoderForUnsignedTypes');
    JsonDecoderForUnsignedTypesClass = $;
  }
  return JsonDecoderForUnsignedTypesClass;
}
//region block: exports
export {
  JsonDecoderForUnsignedTypes as JsonDecoderForUnsignedTypesaowwj2t4rf8t,
  StreamingJsonDecoder as StreamingJsonDecoderyo05rsghf9i6,
};
//endregion

//# sourceMappingURL=StreamingJsonDecoder.mjs.map
